import { FeatureFlag } from '../FeatureFlag';

export const enableLabPoolManagement = new FeatureFlag({
    key: 'enable-lab-pool-management',
    defaultValue: true,
});
